<template>
  <div>
    <van-tabbar v-model="active">
      <van-tabbar-item to="/home">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>资金管理</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item>
        <span>我的</span>
        <template #icon="props">
          <img :src="props.active ? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
import { Tabbar, TabbarItem } from "vant";
import https from "../../utils/request";
export default {
  name: "layout",
  components: {
    Tabbar,
    TabbarItem,
  },
  data: function() {
    return {
      path: "/business/index",
      sidebarData: [],
      levelList: null,
      username: localStorage.getItem("username"),

      active: 0,
      icon: {
        active: require("../../assets/img/bar11.png"),
        inactive: require("../../assets/img/bar1.png"),
      },
      icon2: {
        active: require("../../assets/img/bar33.png"),
        inactive: require("../../assets/img/bar3.png"),
      },
      icon3: {
        active: require("../../assets/img/bar22.png"),
        inactive: require("../../assets/img/bar2.png"),
      },
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
      this.changeRoute();
    },
  },
  // beforeCreate() {
  //   sessionStorage.setItem("ticketLoginFlag", "1");
  // },
  created() {
    this.username = localStorage.getItem("username");
    this.sidebarData = JSON.parse(localStorage.getItem("menu"));
  },
  mounted() {
    this.getBreadcrumb();
    this.changeRoute();
  },
  methods: {
    getBreadcrumb() {
      //$route.matched一个数组 包含当前路由的所有嵌套路径片段的路由记录
      let matched = this.$route.matched.filter((item) => item.name);
      this.levelList = matched;
    },
    changeRoute() {
      //侧边栏  高亮
      let path = this.$route.path;
      switch (path) {
        case "/business":
          this.path = "business/index";
          break;
        case "/fundManage":
          this.path = "/fundManage/fundView";
          break;
        case "/order":
          this.path = "/order/myOrder";
          break;
        case "/entrust":
          this.path = "/entrust/index";
          break;
        case "/mine":
          this.path = "/mine/index";
          break;
        default:
          // if (this.path !== path) {
          // }
          return (this.path = path);
      }
    },
    goBack(index, item) {
      let length = this.levelList.length;
      if (index == 0 || index == length - 1) {
        return false;
      } else if (length == 3) {
        this.$router.back(-1);
      } else if (length > 3 && index == length - 2) {
        this.$router.back(-1);
      } else {
        this.$router.push({
          path: item.path,
        });
      }
    },
    backBtnClick() {
      this.$router.back(-1);
    },
    handleOpen(key, keyPath) {
      // debugger;
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
  },
};
</script>

<style scoped type="text/scss" lang="scss">
.el-main {
  padding: 0;
  min-height: calc(100vh - 66px);
}
.el-aside {
  width: 260px !important;
  max-height: calc(100vh - 66px);
  // padding-top: 16px;
  border-right: solid 1px #e6e6e6;
  .el-menu {
    border: none;
    .el-menu-item {
      text-align: center;
    }
  }
}
.el-submenu {
  text-align: center;
  .el-menu-item {
    height: 36px;
    line-height: 36px;
    font-size: 12px;
    text-align: left;
    padding: 0 0 0 56px !important;
    &.is-active {
      background: rgba(229, 230, 255, 1) !important;
      opacity: 1;
    }
  }
  &.is-active {
    li:not(.is-active) {
      background: #f1f2ff !important;
    }
  }
}
.breadcrumbCo {
  background: rgb(241, 244, 245);
  height: 42px;
  border-bottom: 1px solid rgb(222, 223, 226);
  line-height: 42px;
  padding-left: 27px;
  p.btn {
    margin-top: 5px;
    margin-right: 24px;
    cursor: pointer;
  }
}
</style>
